// extracted by mini-css-extract-plugin
export default {"BrowserTree":"BrowserTree_BrowserTree__bgw+6"};